module.exports = __webpack_public_path__ + "img/right.e21dc2e2.png";